import { useObservableBlock } from 'src/services/rxjs-redux/hook';

export const useCollectionId = (recordId: string) => {
  return useObservableBlock(recordId, (block) => block?.parentId);
};
